import { Icon } from "@mui/material";
import { useStoreActions } from "easy-peasy";
import React from "react";
import MDBox from "./MDBox";
import MDTypography from "./MDTypography";

const Author = ({ name, address, transfers, lateReadings }) => {
  const setTransfers = useStoreActions((actions) => actions.setTransfers);
  const setLateReadings = useStoreActions((actions) => actions.setLateReadings);
  return (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}{" "}
          {transfers?.length > 0 ? (
            <Icon style={{ marginRight: 5 }} onClick={() => setTransfers(transfers)}>
              move_down
            </Icon>
          ) : (
            ""
          )}
          {lateReadings?.length > 0 ? (
            <Icon onClick={() => setLateReadings(lateReadings)}>watch_later</Icon>
          ) : (
            ""
          )}
        </MDTypography>
        <MDTypography variant="caption">{address}</MDTypography>
      </MDBox>
    </MDBox>
  );
};

export default Author;
